import { render } from "./dialogAyudaVBCCPOficios.vue?vue&type=template&id=274c32fc&scoped=true"
import script from "./dialogAyudaVBCCPOficios.vue?vue&type=script&lang=js"
export * from "./dialogAyudaVBCCPOficios.vue?vue&type=script&lang=js"

import "./dialogAyudaVBCCPOficios.vue?vue&type=style&index=0&id=274c32fc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274c32fc"]])

export default __exports__